import React, { useEffect, useState } from 'react';
import {
  Facebook,
  Instagram,
  Twitter,
  ArrowDown,
  EnvelopeFill,
  GeoAltFill,
} from 'react-bootstrap-icons';
import './HomePage.css';
import Logo from '../../../assets/logo_front.png';
import LogoMinistria from '../../../assets/logo_ministria.png';
import Infographic from '../../../assets/infographic.png';
import Team from '../../../assets/team.jpg';
import Ada from '../../../assets/ada.jpg';
import Ing from '../../../assets/ing.png';
import Menu from '../../../components/Menu/Menu';
import {
  doSignupVol,
  getMunicipalities,
  getAllOpps,
  cleanSignUpVolError,
  resetOpportunitiesDocs,
} from '../../../store/actions/actions';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import jwt from 'jsonwebtoken';
import { useTranslation } from 'react-i18next';
import { useToasts } from 'react-toast-notifications';

// import ModalSignUp from '../../Modal/ModalSignUp';
import ModalSignUp from '../../../components/Modal/ModalSignUp';
// import ModalLogin from '../Modal/ModalLogin';

const HomePage = (props) => {
  const [municipalityList, setMunicipalityList] = useState([]);
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();
  const { addToast } = useToasts();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [textInput, setTextInput] = useState();
  const history = useHistory();
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const language = useSelector((state) => state.language);
  const municipalities = useSelector(({ municipalities }) => municipalities?.municipalities);
  const { t, i18n } = useTranslation([]);
  const [example, setExample] = useState(false);

  const signUpVolResponse = useSelector(({ signup }) => signup);

  const token = useSelector(({ token }) => token?.token);
  const confirmed = useSelector(({ login }) => login?.user);
  // useEffect(() => {
  //   if (token) {
  //     if (confirmed.confirmedAccount) {
  //       history.push('/opportunities');
  //     }
  //   }
  // }, [token]);

  useEffect(() => {
    setMunicipalityList(municipalities?.docs);
  }, [municipalities]);

  useEffect(() => {
    if (props.location && props.location.state && props.location.state.scrollToAbout) {
      window.scrollTo(0, document.getElementById('aboutUs').offsetTop);
    } else if (props.location && props.location.state && props.location.state.scrollToContact) {
      window.scrollTo(0, document.getElementById('contactUs').offsetTop);
    } else if (props.location && props.location.state && props.location.state.scrollToSignup) {
      window.scrollTo(0, document.getElementById('signupVol').offsetTop);
    }
  }, []);

  useEffect(() => {
    dispatch(cleanSignUpVolError());
    dispatch(getMunicipalities({ pagination: false }));
  }, []);

  useEffect(() => {
    const script = document.createElement('script');

    script.src = 'https://platform.twitter.com/widgets.js';
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const onClickMenu = () => {
    setExample((prev) => !prev);
  };

  const onSubmit = (data) => {
    setIsLoading(true);
    dispatch(cleanSignUpVolError());
    const { email, password, firstName, lastName, gender, dateOfBirth, municipality } = data;
    dispatch(
      doSignupVol(
        email,
        password,
        firstName,
        lastName,
        gender,
        dateOfBirth,
        municipality,
        language || 'en'
      )
    );
  };

  useEffect(() => {
    if (signUpVolResponse) {
      setIsLoading(signUpVolResponse.loading);
    }
  }, [signUpVolResponse]);

  return (
    <div style={{ width: '100%' }}>
      <Menu onClickMenu={onClickMenu} />

      <div className='video-background'>
        <div className='video-foreground'>
          <iframe
            src='https://www.youtube.com/embed/oIKFRPSey6M?rel=0&amp;controls=0&amp;showinfo=0&amp;autoplay=1&amp;mute=1&amp;loop=1&playlist=oIKFRPSey6M'
            style={{ backgroundColor: '#fff' }}
            allow='autoplay; encrypted-media'
            allowFullScreen
            frameBorder={0}
          ></iframe>
        </div>
      </div>
      <div className='container-sm d-flex justify-content-around align-items-center flex-column'>
        <div className='my-3'></div>
        <div
          className='input-group my-5 border-0'
          style={{
            zIndex: example ? -10 : 10,
          }}
        >
          <input
            type='text'
            className='form-control'
            onChange={(evt) => setTextInput(evt.target.value)}
            value={textInput}
            style={{
              paddingTop: '28px',
              paddingBottom: '28px',
              paddingLeft: '15px',
              paddingLeft: '15px',
              opacity: 0.9,
            }}
            placeholder={t('Home.searchField')}
            aria-label='Search for opportunities'
            aria-describedby='basic-addon2'
          />
          <span
            onClick={() => {
              dispatch(resetOpportunitiesDocs());
              dispatch(
                getAllOpps({
                  page: 1,
                  limit: 10,
                  pagination: true,
                  title: textInput,
                  latestQuery: true,
                })
              );

              history.push('/searchOpportunities', { title: textInput });
            }}
            className='input-group-text'
            id='basic-addon2'
            style={{
              backgroundColor: '#FE9900',
              border: 'none',
              cursor: 'pointer',
              opacity: 0.9,
            }}
          >
            <i
              className='fa fa-search fa-cu-search'
              style={{ color: 'white', fontSize: '20px' }}
            ></i>
          </span>
        </div>
        <div className='my-3'></div>
        <div className='my-5'>
          <img src={LogoMinistria} alt='Logo Ministria' width={250} height={150} />
        </div>
        <div className='my-4'></div>
        <div>
          <ArrowDown color='white' size={40} />
        </div>
      </div>
      <div style={{ backgroundColor: 'white' }} id='signupVol'>
        <div className='container'>
          <p className='h3 text-center mt-5 pt-4'>
            <h2
              style={{
                width: '100%',
                textAlign: 'center',
                borderBottom: '1px solid #999',
                lineHeight: '0.1em',
                margin: '10px 0 20px',
              }}
            >
              <span
                style={{
                  background: '#fff',
                  padding: '0 10px',
                  fontSize: '16px',
                  color: '#707070',
                  letterSpacing: '0.15em',
                  opacity: 1,
                }}
              >
                {t('Home.signUpText')}
              </span>
            </h2>
            <br></br>
            <p style={{ color: '#707070', lineHeight: '30px' }}>
              {/* Sign up for free to be an <br></br>Awesome Volunteer */}
              {t('Home.signUpParagraphFirstPart')} <br></br>
              {t('Home.signUpParagraphSecondPart')}
            </p>
          </p>
        </div>
        <div className='container mt-5'>
          <div className='row'>
            <div className='col-md-7'>
              <img
                className='fluid-img'
                src={Infographic}
                alt='Infographic'
                style={{ width: '100%', height: '100%' }}
              />
            </div>
            <div className='col-md-5 d-flex justify-content-center justify-content-md-end mt-5 mt-md-0'>
              <form
                onSubmit={handleSubmit(onSubmit)}
                className={`${isLoading && 'whirl no-overlay'}`}
                id='signupVol'
              >
                <div className='input-group mb-3'>
                  <span
                    className='input-group-text'
                    id='basic-addon3'
                    style={{
                      fontSize: '15.5px',
                      width: '120px',
                      border: errors.firstName ? 'solid 1px red' : 'none',
                    }}
                  >
                    {t('Home.firstSignUpInputText')}
                  </span>
                  <input
                    type='text'
                    className='form-control'
                    id='basic-url'
                    aria-describedby='basic-addon3'
                    {...register('firstName', { required: true })}
                    style={{
                      fontSize: '15.5px',
                      height: '37.5px',
                      border: errors.firstName ? 'solid 1px red' : 'solid 1px #A5A5A5',
                    }}
                  />
                </div>
                <div className='input-group mb-3'>
                  <span
                    className='input-group-text'
                    id='basic-addon3'
                    style={{
                      fontSize: '15.5px',
                      width: '120px',
                      border: errors.lastName ? 'solid 1px red' : 'none',
                    }}
                  >
                    {t('Home.secondSignUpInputText')}
                  </span>
                  <input
                    type='text'
                    className='form-control'
                    id='basic-url'
                    {...register('lastName', { required: true })}
                    aria-describedby='basic-addon3'
                    style={{
                      fontSize: '15.5px',
                      height: '37.5px',
                      border: errors.lastName ? 'solid 1px red' : 'solid 1px #A5A5A5',
                    }}
                  />
                </div>
                <div className='input-group mb-3'>
                  <span
                    className='input-group-text'
                    id='basic-addon3'
                    style={{
                      fontSize: '15.5px',
                      width: '120px',
                      border: errors.gender ? 'solid 1px red' : 'none',
                    }}
                  >
                    {t('Home.thirdSignUpInputText')}
                  </span>
                  <div className='form-check form-check-inline ms-4'>
                    <input
                      className='form-check-input'
                      type='radio'
                      name='inlineRadioOptions'
                      {...register('gender', { required: true })}
                      id='inlineRadioMale'
                      value='M'
                    />
                    <label
                      className='form-check-label'
                      htmlFor='inlineRadioMale'
                      style={{
                        fontSize: '17.5px',
                        color: errors.gender ? 'red' : 'inherit',
                      }}
                    >
                      {t('Home.radioFirstOption')}
                    </label>
                  </div>
                  <div className='form-check form-check-inline'>
                    <input
                      className='form-check-input'
                      type='radio'
                      name='inlineRadioOptions'
                      id='inlineRadioFemale'
                      {...register('gender', { required: true })}
                      value='F'
                    />
                    <label
                      className='form-check-label'
                      htmlFor='inlineRadioFemale'
                      style={{
                        fontSize: '17.5px',
                        color: errors.gender ? 'red' : 'inherit',
                      }}
                    >
                      {t('Home.radioSecondOption')}
                    </label>
                  </div>
                </div>

                <div className='input-group mb-3'>
                  <span
                    className='input-group-text'
                    id='basic-addon3'
                    style={{
                      fontSize: '15.5px',
                      width: '120px',
                      border: errors.dateOfBirth ? 'solid 1px red' : 'none',
                    }}
                  >
                    {t('Home.fourthSignUpInputText')}
                  </span>
                  <input
                    type='date'
                    className='form-control'
                    id='basic-url'
                    aria-describedby='basic-addon3'
                    {...register('dateOfBirth', { required: true })}
                    style={{
                      fontSize: '15.5px',
                      height: '37.5px',
                      border: errors.dateOfBirth ? 'solid 1px red' : 'solid 1px #A5A5A5',
                    }}
                  />
                </div>

                <div className='input-group mb-3'>
                  <span
                    className='input-group-text'
                    id='basic-addon3'
                    style={{
                      fontSize: '15.5px',
                      width: '120px',
                      border: errors.email ? 'solid 1px red' : 'none',
                    }}
                  >
                    {t('Home.fifthSignUpInputText')}
                  </span>
                  <input
                    type='email'
                    className='form-control'
                    id='basic-url'
                    aria-describedby='basic-addon3'
                    {...register('email', {
                      required: true,
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: 'email does not match',
                      },
                    })}
                    style={{
                      fontSize: '15.5px',
                      height: '37.5px',
                      border: errors.email ? 'solid 1px red' : 'solid 1px #A5A5A5',
                    }}
                  />
                </div>

                <div className='input-group mb-3'>
                  <span
                    className='input-group-text'
                    id='basic-addon3'
                    style={{
                      fontSize: '15.5px',
                      width: '120px',
                      border: errors.password ? 'solid 1px red' : 'none',
                    }}
                  >
                    {t('Home.sixthSignUpInputText')}
                  </span>
                  <input
                    type='password'
                    className='form-control'
                    id='basic-url'
                    {...register('password', { required: true })}
                    aria-describedby='basic-addon3'
                    style={{
                      fontSize: '15.5px',
                      height: '37.5px',
                      border: errors.password ? 'solid 1px red' : 'solid 1px #A5A5A5',
                    }}
                  />
                </div>

                <div className='input-group mb-3'>
                  <span
                    className='input-group-text'
                    id='basic-addon3'
                    style={{
                      fontSize: '15.5px',
                      width: '120px',
                      border: errors.municipality ? 'solid 1px red' : 'none',
                    }}
                  >
                    {t('Home.seventhSignUpInputText')}
                  </span>
                  <select
                    className='form-select'
                    aria-label='Default select example'
                    {...register('municipality', {
                      required: true,
                      validate: (value) => value !== 'choose',
                    })}
                    style={{
                      fontSize: '15px',
                      height: '37.5px',
                      border: errors.municipality ? 'solid 1px red' : 'solid 1px #A5A5A5',
                    }}
                  >
                    <option selected value='choose'>
                      {t('Home.dropDownTextSeventhInput')}
                    </option>
                    {municipalityList
                      ? municipalityList.map((municipality) => {
                          return (
                            <option value={municipality._id} key={municipality._id}>
                              {municipality.localisations[language].name}
                            </option>
                          );
                        })
                      : null}
                  </select>
                </div>
                {signUpVolResponse && signUpVolResponse.error && (
                  <div
                    style={{
                      justifyContent: 'center',
                      display: 'flex',
                      width: '100%',
                    }}
                  >
                    <p style={{ color: 'red' }}>{signUpVolResponse.error}</p>
                  </div>
                )}
                <div className='input-group mb-3 d-flex justify-content-end'>
                  <button
                    type='submit'
                    className='btn btn-warning border'
                    style={{ fontSize: '15px' }}
                  >
                    {t('Home.signUpHomeButton')}
                  </button>
                </div>
                <p className='lead mt-3'>
                  {t('Home.homeQuestion')}{' '}
                  <a
                    onClick={() => toggle()}
                    // href='#'
                    style={{ color: '#FF902B', cursor: 'pointer' }}
                  >
                    {t('Home.questionParagraph')}
                  </a>
                </p>
              </form>
            </div>
          </div>
        </div>
        <div style={{ height: '75px' }}></div>
        <div style={{ backgroundColor: '#F4F4F4' }}>
          <div className='container' id='aboutUs'>
            <div className='row pt-3'>
              <div className='pt-3 pb-4'>
                <h2
                  style={{
                    width: '100%',
                    textAlign: 'center',
                    borderBottom: '1px solid #999',
                    lineHeight: '0.1em',
                    margin: '10px 0 20px',
                  }}
                >
                  <span
                    style={{
                      background: '#fff',
                      padding: '0 10px',
                      fontSize: '16px',
                      color: '#707070',
                      letterSpacing: '0.15em',
                      backgroundColor: '#F4F4F4',
                      opacity: 1,
                    }}
                  >
                    {t('Home.aboutUs.aboutUsTitle')}
                  </span>
                </h2>
              </div>

              <div className='col-md-6 px-2 py-2'>
                <p>{t('Home.aboutUs.aboutFirstParagraph')}</p>
                <p>{t('Home.aboutUs.aboutSecondParagraph')}</p>
                <p>{t('Home.aboutUs.aboutThirdParagraph')}</p>
              </div>
              <div className='col-md-6 px-2 py-2'>
                <img src={Team} className='img-responsive' style={{ width: '100%' }} />
              </div>
            </div>
          </div>
        </div>
        <div style={{ height: '20px', backgroundColor: '#F4F4F4' }}></div>
        <div style={{ backgroundColor: '#FE9900' }}>
          <div className='container'>
            <div className='row'>
              <div className='pt-3 pb-4'>
                <h2
                  style={{
                    width: '100%',
                    textAlign: 'center',
                    borderBottom: '1px solid #fff',
                    lineHeight: '0.1em',
                    margin: '10px 0 20px',
                  }}
                >
                  <span
                    style={{
                      background: '#fff',
                      padding: '0 10px',
                      fontSize: '16px',
                      color: '#FFF',
                      letterSpacing: '0.15em',
                      backgroundColor: '#FE9900',
                      opacity: 1,
                    }}
                  >
                    {t('Home.socialText')}
                  </span>
                </h2>
              </div>
              <div className='col-md-6 px-2 py-2'>
                <iframe
                  src='https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fkosovovolunteers%2F&tabs=none&width=500&height=500&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId'
                  height='70'
                  width='1000'
                  style={{ border: 'none', overflow: 'hidden' }}
                  frameBorder={0}
                  allowFullScreen={true}
                  allow='autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share'
                ></iframe>
              </div>
              <div
                className='col-md-6 mt-2 px-2 py-2'
                style={{
                  overflowY: 'scroll',
                  border: '1px solid #f6f7f9',
                  background: '#f6f7f9',
                  height: '220px',
                }}
              >
                <a
                  className='twitter-timeline'
                  href='https://twitter.com/KosInnovations?ref_src=twsrc%5Etfw'
                >
                  {t('Home.tweetsText')}
                </a>
              </div>
            </div>
            <div className='col-sm-12 text-center mt-5 pb-3'>
              <div className='social-share'>
                <h4>{t('Home.shareWebSite')}</h4>
                <div className='social-wrapper twitter-share'>
                  {/* <!-- <div className="count twitter-count"></div> -->
                                    <!-- <i className="fa fa-caret-down"></i> --> */}
                  <a
                    href='https://twitter.com/share?url=https://twitter.com/KosInnovations'
                    className='twitter-share-button'
                    data-size='large'
                    data-show-count='false'
                    target='_blank'
                  >
                    <button className='tw'>
                      <Twitter /> {t('Home.socialMediaTw')}
                    </button>
                  </a>
                </div>

                <div
                  className='social-wrapper facebook-share ms-2'
                  style={{ position: 'relative', bottom: '9px' }}
                >
                  {/* <!-- <div className="count facebook-count"></div> -->
                                    <!-- <i className="fa fa-caret-down"></i> --> */}
                  <a
                    target='_blank'
                    href='https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fm.facebook.com%2Fkosovovolunteers%2F&amp;src=sdkpreparse'
                    className='fb-xfbml-parse-ignore'
                  >
                    <button
                      className='fb'
                      style={{
                        padding: '1px 11px 3px 9px',
                        borderRadius: '4px',
                      }}
                    >
                      <Facebook style={{ marginRight: '4px', marginBottom: '3px' }} />{' '}
                      {t('Home.socialMediaName')}
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div style={{ height: '20px', backgroundColor: '#FE9900' }}></div>
        <div style={{ backgroundColor: '#FFF' }}>
          <div className='container' id='contactUs'>
            <div className='row'>
              <div className='item-details row'>
                <div className='item-body py-5'>
                  <h3
                    style={{
                      textAlign: 'center',
                      textTransform: 'uppercase',
                      color: '#656565',
                    }}
                  >
                    {t('Home.contactUs.contactUsTitle')}
                  </h3>
                  <hr></hr>
                  <div className='row' style={{ fontSize: '15px', color: '#656565' }}>
                    <div className='col-md-4'>
                      <i className='fa fa-phone me-3'></i>
                      +383 38200222/59
                    </div>
                    <div className='col-md-4'>
                      <i className='fa fa-envelope me-3'></i>
                      <a
                        href='mailto:kastriot.mehmetaj@rks-gov.net'
                        target='_top'
                        id='mailToContact'
                      >
                        kastriot.mehmetaj@rks-gov.net
                      </a>
                    </div>
                    <div className='col-md-4'>
                      <i className='fa fa-map-marker me-3'></i>
                      Str. Sheshi Nëna Terezë, Pristina, Kosovo
                    </div>
                  </div>
                  <hr></hr>
                </div>
              </div>
              <div className='col-md-5'>
                <p className='lead fw-bold pt-4 pb-4'>
                  {' '}
                  {t('Home.contactUs.administratorContact')}{' '}
                </p>
                <p>
                  <span style={{ padding: '15px', backgroundColor: '#FE9900' }}>
                    <EnvelopeFill size={20} color='white' />
                  </span>
                  <span className='ms-4'>kastriot.mehmetaj@rks-gov.net</span>
                </p>
                <br></br>
                <br></br>
                <p>
                  <span style={{ padding: '15px', backgroundColor: '#FE9900' }}>
                    <GeoAltFill size={20} color='white' />
                  </span>
                  <span className='ms-4'>Str. Sheshi Nëna Terezë, Pristina, Kosovo</span>
                </p>
              </div>
              <div className='col-md-7'>
                <p className='lead fw-bold mt-5 mt-md-0 pt-md-5 pb-4'>
                  {' '}
                  {t('Home.contactUs.contactText')}
                </p>
                <p className='h4 fw-bolder text-center'>{t('Home.contactUs.contactSupporters')}</p>
                <div className='row pt-4 '>
                  <div className='col-md-6 px-4 py-4 px-md-2 py-md-2'>
                    <a
                      href='http://www.entwicklung.at/countries_and_regions/danube_regionwestern_balkans/kosovo'
                      target='_blank'
                    >
                      <img
                        src={Ada}
                        style={{ height: '100px' }}
                        className='mx-auto d-block img-fluid'
                      />
                    </a>
                  </div>
                  <div className='col-md-6 px-4 py-4 px-md-2 py-md-2'>
                    <a href='https://www.ing.com/en.htm' target='_blank'>
                      <img
                        src={Ing}
                        style={{ height: '50px' }}
                        className='mx-auto d-block img-fluid'
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style={{ backgroundColor: '#FFF', height: '50px' }}></div>
      </div>
      <ModalSignUp modal={modal} toggle={toggle} />
    </div>
  );
};

export default HomePage;
